// generated by the plop

import { Injectable } from '@angular/core';
import { Action, Selector, State, StateContext } from '@ngxs/store';
import { append, insertItem, patch, updateItem } from '@ngxs/store/operators';
import { PROGRESS_STATUSES } from 'symbols';
import { InvoiceService } from '../../services/invoice.service';
import {
  ClearScrollPositionInvoiceList, CreatedInvoiceByWS,
  GetInvoiceList,
  GetInvoiceListError,
  GetInvoiceListSuccess,
  SetLastOpenedInvoiceId, UpdatedInvoiceByWS,
  UpdateScrollPositionInvoiceList
} from './invoice-list.actions';
import { INVOICE_LIST_STATE_DEFAULT, InvoiceListStateModel } from './invoice-list.model';

@State({ name: 'InvoiceList', defaults: INVOICE_LIST_STATE_DEFAULT })
@Injectable()
export class InvoiceListState {
  @Selector()
  static invoiceList(state: InvoiceListStateModel): InvoiceListStateModel['invoiceList'] {
    return state.invoiceList;
  }

  @Selector()
  static loadInvoiceListStatus(state: InvoiceListStateModel): InvoiceListStateModel['loadInvoiceListStatus'] {
    return state.loadInvoiceListStatus;
  }

  @Selector()
  static lastOpenedDocId(state: InvoiceListStateModel): InvoiceListStateModel['lastOpenedDocId'] {
    return state.lastOpenedDocId;
  }

  @Selector()
  static scrollPosition(state: InvoiceListStateModel): InvoiceListStateModel['scrollPosition'] {
    return state.scrollPosition;
  }

  constructor(private invoiceService: InvoiceService) {
  }

  @Action(GetInvoiceList)
  getInvoiceList(ctx: StateContext<InvoiceListStateModel>, { filter, lazy }: GetInvoiceList): void {
    if (lazy) {
      const next = ctx.getState().invoiceList?.links?.next;
      if (next) {
        ctx.patchState({
          loadInvoiceListStatus: PROGRESS_STATUSES.IN_PROGRESS
        });
        this.invoiceService.getInvoiceListLazy(next).subscribe({
          next: res => ctx.dispatch(new GetInvoiceListSuccess(res, lazy)),
          error: error => ctx.dispatch(new GetInvoiceListError(error))
        });
      }
    } else {
      ctx.patchState({
        loadInvoiceListStatus: PROGRESS_STATUSES.IN_PROGRESS
      });
      this.invoiceService.getInvoiceList(filter).subscribe({
        next: res => ctx.dispatch(new GetInvoiceListSuccess(res, lazy)),
        error: error => ctx.dispatch(new GetInvoiceListError(error))
      });
    }
  }

  @Action(GetInvoiceListSuccess)
  getInvoiceListSuccess(ctx: StateContext<InvoiceListStateModel>, { invoiceList, lazy }: GetInvoiceListSuccess): void {
    ctx.patchState({
      loadInvoiceListStatus: PROGRESS_STATUSES.SUCCESS
    });
    if (lazy) {
      ctx.setState(patch({
        invoiceList: patch({
          data: append([...invoiceList.data]),
          links: invoiceList.links,
          meta: invoiceList.meta
        })
      }));
    } else {
      ctx.patchState({
        invoiceList
      });

    }
  }

  @Action(GetInvoiceListError)
  getInvoiceListError(ctx: StateContext<InvoiceListStateModel>, { error }: GetInvoiceListError): void {
    ctx.patchState({
      loadInvoiceListStatus: PROGRESS_STATUSES.FAIL
    });
  }


  @Action(ClearScrollPositionInvoiceList)
  clearScrollPositionInvoiceList(ctx: StateContext<InvoiceListStateModel>): void {
    ctx.patchState({ scrollPosition: 0 });
  }

  @Action(UpdateScrollPositionInvoiceList)
  updateScrollPosition(ctx: StateContext<InvoiceListStateModel>, { position }: UpdateScrollPositionInvoiceList): void {
    ctx.patchState({ scrollPosition: position });
  }

  @Action(SetLastOpenedInvoiceId)
  setLastOpenedDocId(ctx: StateContext<InvoiceListStateModel>, { invoiceId }: SetLastOpenedInvoiceId): void {
    ctx.patchState({ lastOpenedDocId: invoiceId });
  }


  @Action(UpdatedInvoiceByWS)
  updatedOrderBuWS(ctx: StateContext<InvoiceListStateModel>, { invoice }: UpdatedInvoiceByWS): void {

    ctx.setState(patch({
      invoiceList: patch({
        data: updateItem(o => o?.id === invoice.id, invoice)
      })
    }));
  }

  @Action(CreatedInvoiceByWS)
  createdOrderByWS(ctx: StateContext<InvoiceListStateModel>, { invoice }: CreatedInvoiceByWS): void {
    ctx.setState(patch({
      invoiceList: patch({
        data: insertItem(invoice, 0),
        meta: patch({
          totalItems: ctx.getState().invoiceList?.meta?.totalItems + 1
        })
      })
    }));
  }
}


